export const Loader = ({moreClasses}) => {
    return <div className={`loader ${moreClasses ? moreClasses : ''}`}><div></div><div></div><div></div><div></div>
        <div></div><div></div><div></div><div></div></div>
}